interface EmptyStateProps {
  text: string;
}

export function EmptyState({ text }: EmptyStateProps) {
  return (
    <div className="panel-surface rounded-panel p-6">
      <p className="text-muted">{text}</p>
    </div>
  );
}
